import AuthContext from '../../app/contexts/auth';
import ConnectionProvider from '../../app/contexts/connection';
import PoolPage from './pool-page';

export default function Pool() {
    const { user } = AuthContext.useAuth();

    return (
        <ConnectionProvider.ConnectionProvider
            group="PoolGlobal"
            sulaHubId={user?.carrier?.sulahub_id}
        >
            <PoolPage />
        </ConnectionProvider.ConnectionProvider>
    );
}
